export default __webpack_public_path__ + "static/media/freshFruitsDesktop.9d667562.png";